import { render, staticRenderFns } from "./MultiselectForm.vue?vue&type=template&id=d67a2346&scoped=true"
import script from "./MultiselectForm.vue?vue&type=script&lang=js"
export * from "./MultiselectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67a2346",
  null
  
)

export default component.exports